/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const t={idleOpacity:.8,navigatingOpacity:.4,maxDelta:.1,tiltFadeStart:20,tiltFadeEnd:30,altitudeStart:1e4,altitudeEnd:2e4};export{t as hudFragmentOpacityParameters};
